// import { ComponentRenderHooks } from "@launchos/plugins/types";
import * as React from "react";
// import { has } from "lodash";
// import { ComponentTypes } from "../../types";
import { Helmet } from "react-helmet";
// import { generateInlineStyle } from "@launchos/modules/editor/Builder/Properties/RichEditor/utilities";
// import { EditorMode } from "@/Apps/Pages/Editor/types";

// import { Icon, IconTypes } from "../Icon";
// import Icon from "../Icon";

import { ComponentRenderHooks } from "@/plugins/types";
import { ComponentTypes, EditorMode } from "@/Apps/Pages/Editor/types";

import { ListItemTypes, ListItemProps, PluginProps } from "./types";
import { generateInlineStyle } from "@/Apps/Pages/Properties/RichEditor/utilities";
import Icon from "../Icon/live";
import { LiquidRenderer, parseLiquidObject } from "@/Apps/Pages/Page/LiquidRenderer";

export const ListItem: React.FC<ListItemProps> = ({
  style,
  properties,
  icon,
  iconSource,
  children,
  iconStyle,
  contentStyle,
  containerStyle = {},
  type,
  html,
  id,
  mode,
}) => {
  // const Icon = icon;
  return (
    <li
      data-testid="WC-LISTITEM-LIVE"
      style={parseLiquidObject({
        display: type === ListItemTypes.BLOCK ? "block" : "flex",
        ...style,
        ...properties,
      })}
    >
      <Helmet>
        <style type="text/css">
          {generateInlineStyle({ properties, id }, EditorMode.LIVE)}
        </style>
      </Helmet>
      <div style={parseLiquidObject({ display: "flex", ...containerStyle })}>
        {icon && (
          <div
            style={parseLiquidObject({
              display: "inline-block",
              ...iconStyle,
              textAlign: "left",
            })}
          >
            <Icon
              type={icon}
              source={iconSource}
              style={iconStyle}
              // style={{
              //   ...(has(iconStyle, "fontSize")
              //     ? { fontSize: iconStyle.fontSize }
              //     : {}),
              // }}
            />
          </div>
        )}
        <div
          style={parseLiquidObject({
            display: "inline-block",
            ...contentStyle,
            textAlign: "left",
          })}
          // {...(!children ? { dangerouslySetInnerHTML: { __html: html } } : {})}
        >
          {!children && <LiquidRenderer html={html} />}
          {children && children}
        </div>
      </div>
    </li>
  );
};

const ListItemPluginComponent: React.FC<PluginProps> = ({ settings }) => {
  return <ListItem {...settings} />;
};

export const onComponentRender = (hook, payload, actions) => {
  if (
    hook.id === ComponentRenderHooks.WEBCOMPONENT &&
    payload.type === ComponentTypes.LISTITEM
  ) {
    return [ListItemPluginComponent];
  }
};

export default ListItem;
